// extracted by mini-css-extract-plugin
export var actionButton = "_5z-1";
export var actionButtons = "_5z-2";
export var actions = "_5z-0";
export var aiUnread = "_5z-10";
export var alignCenter = "_5z-h";
export var backWrapper = "_5z-3";
export var cellContainer = "_5z-4";
export var checkboxContainer = "_5z-5";
export var contentContainer = "_5z-6";
export var contentHeader = "_5z-8";
export var conversationsTableWrapper = "_5z-s";
export var draftReplyBadgeContainer = "_5z-m";
export var dropdownItem = "_5z-b";
export var dropdownItemsContainer = "_5z-a";
export var dropdownTitle = "_5z-c";
export var errorIcon = "_5z-7";
export var filter = "_5z-d";
export var gray = "_5z-i";
export var headerActionButtons = "_5z-e";
export var headerCheckboxContainer = "_5z-f";
export var icon = "_5z-j";
export var menuContainer = "_5z-k";
export var noMoreTicketsIcon = "_5z-12";
export var noMoreTicketsSubText = "_5z-13";
export var oneLine = "_5z-l";
export var optionsButton = "_5z-n";
export var plus = "_5z-o";
export var portalButtonsWrapper = "_5z-g";
export var red = "_5z-p";
export var scrolledTop = "_5z-9";
export var search = "_5z-q";
export var selectedConversationsCount = "_5z-r";
export var spinner = "_5z-t";
export var strong = "_5z-u";
export var summaryCell = "_5z-v";
export var tableContainer = "_5z-11";
export var tagContainer = "_5z-w";
export var threeDots = "_5z-x";
export var twoLines = "_5z-y";
export var unread = "_5z-z";